import CustomPage from "@/views/correspondence/components/list";
export default {
  name: "correspondence-task-details",
  components: {
    CustomPage: CustomPage
  }
};